export default __webpack_public_path__ + "static/media/case-thumbnail.f4501b0a.jpg";